var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53268 27.2007L27.7994 17.2273C28.8794 16.7607 28.8794 15.2407 27.7994 14.774L4.53268 4.80067C3.65268 4.41401 2.67935 5.06734 2.67935 6.01401L2.66602 12.1607C2.66602 12.8273 3.15935 13.4007 3.82602 13.4807L22.666 16.0007L3.82602 18.5073C3.15935 18.6007 2.66602 19.174 2.66602 19.8407L2.67935 25.9873C2.67935 26.934 3.65268 27.5873 4.53268 27.2007Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fc7e95ef92a7b55b97539161219fc57c.svg";
export { ForwardRef as ReactComponent };